import { Center } from '@hover/blueprint';
import React from 'react';

import { UploadHomeownerPhotoSheet } from '../SheetMenu/UploadHomeownerPhotoSheet';

const CustomizeUpload = () => (
  <Center minHeight="100vh">
    <UploadHomeownerPhotoSheet
      px={{ base: 500, tablet: 800 }}
      width={{ base: '100%', width250: '70%', tablet: '100%' }}
    />
  </Center>
);

export { CustomizeUpload };
